const DEVICE_TYPE = {
    DESKTOP: 'desktop',
    MOBILE: 'mobile',
    TABLET: 'tablet',
};
export default DEVICE_TYPE;
//# sourceMappingURL=deviceType.js.map